import { render } from "./AdminEmptyPage.vue?vue&type=template&id=3caef590&scoped=true"
import script from "./AdminEmptyPage.vue?vue&type=script&lang=js"
export * from "./AdminEmptyPage.vue?vue&type=script&lang=js"

import "./AdminEmptyPage.vue?vue&type=style&index=0&id=3caef590&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3caef590"]])

export default __exports__